import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const Lightning = forwardRef(({ size = 'medium', fill = 'currentColor', ...props }, ref) => {
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: _jsx("path", { d: "M15.208 7.083h-4.992L12.028.79a.63.63 0 0 0-.32-.718.64.64 0 0 0-.27-.072h-4.98a.64.64 0 0 0-.634.518L4.173 11.363a.63.63 0 0 0 .37.665.6.6 0 0 0 .265.055H8.75l-.69 7.532a.34.34 0 0 0 .23.363.344.344 0 0 0 .404-.149l7.054-11.806a.63.63 0 0 0 .001-.63.64.64 0 0 0-.54-.31Z" }) }));
});
Lightning.displayName = 'Lightning';
Lightning.__iconComponentType = 'standard';
export default Lightning;
//# sourceMappingURL=Lightning.js.map